export const SITE_URL =
    process.env.REACT_APP_SITE_URL || "https://upncomer.co";

export const DEFAULT_SEO = {
    title:
        "UpNComer | The Operating System for Artists and Labels",

    description:
        "UpNComer helps independent artists manage every aspect of their music career, from campaigns to distribution, all in one place, so you can focus on making music while we help handle the rest.",

    image:
        `${SITE_URL}/og-image.png`,
};

export const PAGE_OG_IMAGES = {
    home:              `${SITE_URL}/og-image.png`,
    features:          `${SITE_URL}/og-image.png`,
    pricing:           `${SITE_URL}/og-image.png`,
    distribution:      `${SITE_URL}/og-image.png`,
    blog:              `${SITE_URL}/og-image.png`,
    tutorials:         `${SITE_URL}/og-image.png`,
    caseStudies:       `${SITE_URL}/og-image.png`,
    communityUpdates:  `${SITE_URL}/og-image.png`,
    helpCenter:        `${SITE_URL}/og-image.png`,
    ourStory:          `${SITE_URL}/og-image.png`,
};